import React from 'react'
import { Table,
  TableCell,
  TableHead,
  TableRow,
  Hidden,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Info } from '@material-ui/icons';
import SubsectionTooltip from './SubsectionTooltip';
import { QRCode } from "react-qr-svg";

const styles = theme => ({
  compactTableCell:{
    padding: '0px 0px 0px 15px',
    "@media print": {
      padding: " 1px !important"
    }
  },
  hiddenPrint:{
    display: 'block',
    "@media print":{
      display: 'none',
    },
  },
  showPrint:{
    display: 'none',
    border:0,
    margin:0,
    padding:0,
    marginTop: 20,
    "@media print":{
      display: 'block',
      maxHeight: '8vh',
      width: '850px',
      marginLeft: '-40px',
      padding:0
    },
  },
  infoIcon:{
    "@media print":{
      color: '#000',
    }
  }
});

class DocAdditionalDetails extends React.Component {

  render () {
    const {noticeAttributes, classes, noticesList, print, needsAproval, originalTo} = this.props

    let overrideClasses = classes.hiddenPrint;

    if(print){
      overrideClasses = classes.showPrint;
    }

    let renderDetails = null;

    if(!!noticesList && noticesList.length > 0){
      renderDetails = (
        <div className={overrideClasses}>
          <Hidden only={['xs','sm']}>
            <Table>
              <TableHead>
                <TableRow  align={"left"} style={{height:'30px'}}>
                  <TableCell className={classes.compactTableCell}>Fecha/Hora envío</TableCell>
                    <TableCell className={classes.compactTableCell} align={"left"}>Enviado por</TableCell>
                    <TableCell className={classes.compactTableCell} align={"left"}>Para</TableCell>
                    <TableCell className={classes.compactTableCell} align={"left"}>Nota</TableCell>
                    <TableCell className={classes.compactTableCell} align={"left"}>Autorizado</TableCell>
                </TableRow>
              </TableHead>
              <tbody>
              {noticeAttributes.reverse().map(d => (
                <TableRow key={d.id} style={{marginBottom: '1em', fontSize: '12px'}}>
                  <TableCell className={classes.compactTableCell} key={'tc'+d.id}  style={{width: '14%'}}>
                    {d.date}
                  </TableCell>
                  <TableCell className={classes.compactTableCell} style={{width: '25%'}}>
                    {
                      needsAproval ?
                      d.from.name.title +' '+ d.from.name.full +' (Revisor de: ' + originalTo + ')' :
                      d.from.name.title +' '+ d.from.name.full
                    }
                  </TableCell>
                  <TableCell className={classes.compactTableCell} style={{width: '24%'}}>
                      {  d.notice_users_attributes.map(nu => (
                        <span key={'pn'+nu.id}>{nu.external? nu.ext_name : nu.to.name.title+' '+nu.to.name.full}<br/></span>
                      ))}
                    </TableCell>
                  <TableCell className={classes.compactTableCell} style={{width: '29%'}}>
                    {d.note}
                  </TableCell>
                  <TableCell className={classes.compactTableCell} style={{width: '1%'}} align={"center"}>
                    {d.authorized?
                      <SubsectionTooltip
                         placement="right"
                         title={<QRCode style={{ width: 60}} value={"Reenvío autorizado el: "+d.date} level="L" />}>
                         <Info color="primary" fontSize="default" className={classes.infoIcon} style={{ paddingTop: 1 }}/>
                       </SubsectionTooltip> : null}
                  </TableCell>
                </TableRow>
              ))}
              </tbody>
            </Table>
          </Hidden>
          <Hidden only={['md','lg','xl']}>
            <List className="list_main">
             {noticeAttributes.reverse().map(d => {
              return (
                  <div key={d.id}>
                    <ListItem alignItems="flex-start"  key={d.id} style={{ paddingLeft: 0, paddingRight: 0 }}>
                      <ListItemText
                      className={'desc_list_read'}
                      primary={
                        <React.Fragment>
                          <Typography component="span">
                            {
                              needsAproval ?
                              d.from.name.title +' '+ d.from.name.full +' (Revisor de: ' + originalTo + ')' :
                              d.from.name.title +' '+ d.from.name.full
                            }
                            <span className="date_list">
                              {d.date}
                            </span>
                          </Typography>
                        </React.Fragment>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography component="span">
                            {'Para: ' }
                            {  d.notice_users_attributes.map(nu => (
                              <span key={'pn'+nu.id}>{nu.external? nu.ext_name : nu.to.name.title+' '+nu.to.name.full}<br/></span>
                            ))}
                          </Typography>
                          <Typography component="span" style={{overflow: 'hidden'}}>
                            {'Nota: '+d.note}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider/>
                </div>)
            })}
            </List>
          </Hidden>
        </div>
      );
    }

    return (renderDetails);

  }
}

export default withStyles(styles)(DocAdditionalDetails);



// WEBPACK FOOTER //
// ./src/components/DocAdditionalDetails.js